import App from './App';
import ReactDOM from 'react-dom';
import './app/shared/utils/chart';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import './app/assets/styles/global.scss';
import * as Sentry from '@sentry/react';
import initSentry from './sentry';

import 'nprogress/nprogress.css';
import { SidebarProvider } from './app/shared/contexts/SidebarContext';

initSentry();

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={<p>Ha ocurrido un error en la aplicación</p>}>
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);

serviceWorker.unregister();
